/**
 * @module utils/chartSettingsSession
 * @description ChartSettings Context 写入 session（datalabChartsCatch.chartSettings）的字段裁剪
 *
 * 与 DVA 查询态分开存储于同一 session key，登录失效后一并恢复。
 * 离开页正常卸载时 useUnmount 清空 session；F5 刷新可能残留，仅 isUserFailure 时回放。
 */

import type { IChartSettingsState } from '../types';

/** 写入 datalabChartsCatch 的 ChartSettings 快照（含未 Confirm 的 draft） */
export type TChartSettingsSessionCache = Pick<
  IChartSettingsState,
  | 'chartsModal'
  | 'recalcTriggerVersion'
  | 'activeTabs'
  | 'base'
  | 'draft'
  | 'hasDraft'
>;

/** 从完整 Context state 裁剪可序列化、需恢复的字段 */
export function pickChartSettingsForSession(
  state: IChartSettingsState,
): TChartSettingsSessionCache {
  return {
    chartsModal: state.chartsModal,
    recalcTriggerVersion: state.recalcTriggerVersion,
    activeTabs: state.activeTabs,
    base: state.base,
    draft: state.draft,
    hasDraft: state.hasDraft,
  };
}

/** session 反序列化后的结构校验，避免脏数据 PATCH 进 Context */
export function isChartSettingsSessionCache(
  value: unknown,
): value is TChartSettingsSessionCache {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const cache = value as TChartSettingsSessionCache;
  return (
    typeof cache.base === 'object' &&
    cache.base !== null &&
    typeof cache.draft === 'object' &&
    cache.draft !== null &&
    typeof cache.hasDraft === 'object' &&
    cache.hasDraft !== null
  );
}
